import { render, staticRenderFns } from "./StaffPackageRequestList.vue?vue&type=template&id=549c628f&scoped=true&"
import script from "./StaffPackageRequestList.vue?vue&type=script&lang=ts&"
export * from "./StaffPackageRequestList.vue?vue&type=script&lang=ts&"
import style0 from "./StaffPackageRequestList.vue?vue&type=style&index=0&id=549c628f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549c628f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAlert,VCard,VChip,VCol,VDataTable,VDivider,VPagination,VRow,VSpacer,VTextField,VToolbar})
